
export const SUCCESS_CODE = 0;

export const USER_INFO_STORAGE = 'forchange-entry__applet-transfer-page-user-info'